import titleStyle from './css/SectionTitle.module.css';
import sstyles from './css/StaffMgmt.module.css';
import styles from './css/Categories.module.css';
import { useContext, useState } from 'react';
import { MenuContext } from '../DashBoard';
import restApi from '../../../helperFunctions/Api2';

const QuestionKind = {
    'Multi Choice Question': 'mcq',
    'Fill in the Blank': 'fib',
    'True or False': 'tf'
};
export default function GenerateQuestions () {
    const { setModalToggle, setModalText, setShowLoading } = useContext(MenuContext);
    const [type, setType] = useState('text');
    const [noOfQuestions, setNoOfQuestions] = useState(10);
    const [questionKind, setQuestionKind] = useState(QuestionKind['Multi Choice Question']);

    const handleGenerate = () => {
        setShowLoading(true);
        const payload = {
            type,
            mimeType: type === 'file' ? 'application/pdf' : 'text/plain',
            noOfQuestions,
            questionKind,
        };

        if (type === 'file') {
            const fileInput = document.getElementById('file-upload');
            const file = fileInput?.files[0];
            if (!file) {
                setModalText('Please select a file to upload');
                setModalToggle(true);
                setShowLoading(false);
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                payload.file = reader.result.split(',')[1];
                processPayload(payload);
            };
            reader.readAsDataURL(file);
        } else {
            const textInput = document.getElementById('text-input');
            const text = textInput?.value || '';
            if (!text.trim()) {
                setModalText('Please enter some text');
                setModalToggle(true);
                setShowLoading(false);
                return;
            }
            if (text.length < 400) {
                setModalText('Text must be at least 400 characters long');
                setModalToggle(true);
                setShowLoading(false);
                return;
            }
            payload.text = text;
            processPayload(payload);
        }
    };

    const processPayload = (payload) => {
        restApi.PostApi('/ai/generate-question', payload, true).then((res) => {
            console.log('Questions generated:', res);
            if (res.isSuccessful) {
                setModalText(<DisplayQuestions questions={res.data} />);
            } else {
                setModalText(res.message || 'Error generating questions');
            }
            setModalToggle(true);
        }).catch((err) => {
            console.log('Error generating questions:', err);
            setModalText('Error generating questions');
            setModalToggle(true);
        }).finally(() => {
            setShowLoading(false);
        });
    };

    return (
        <div className={`${sstyles.baseView} full-port`}>
            <h1 className={`${sstyles.title}`}>Generate Questions</h1>
            <div className={`${sstyles.subView}`}>
                <div className={titleStyle.sectionTitle}>
                    <h3 className={titleStyle.h3}>Generate Questions</h3>
                </div>
                <div className='full-port'>
                    <div className={`${styles.mainView}`}>
                        <div className={`${styles.form}`}>
                            <label htmlFor="question-type" className={`${styles.label}`}>
                                <span>Generate question from</span>
                                <select
                                    id="question-type"
                                    className={`${styles.select}`}
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                >
                                    <option value="text">Text</option>
                                    <option value="file">File</option>
                                </select>
                            </label>
                            {type === 'file' ? (
                                <label htmlFor="file-upload" className={`${styles.label}`}>
                                    <span>Upload PDF</span>
                                    <input
                                        type="file"
                                        id="file-upload"
                                        className={`${styles.input}`}
                                        accept=".pdf"
                                    />
                                </label>
                            ) : (
                                <label htmlFor="text-input" className={`${styles.label}`}>
                                    <span>Enter Text</span>
                                    <textarea
                                        id="text-input"
                                        className={`${styles.textarea}`}
                                        rows={5}
                                        placeholder="Enter your text here"
                                    />
                                </label>
                            )}
                            <label htmlFor="no-of-questions" className={`${styles.label}`}>
                                <span>Number of Questions</span>
                                <input
                                    type="number"
                                    id="no-of-questions"
                                    className={`${styles.input}`}
                                    value={noOfQuestions}
                                    onChange={(e) => setNoOfQuestions(e.target.valueAsNumber)}
                                    placeholder="Enter number of questions"
                                />
                            </label>
                            <label htmlFor="question-kind" className={`${styles.label}`}>
                                <span>Question Kind</span>
                                <select
                                    id="question-kind"
                                    className={`${styles.select}`}
                                    value={questionKind}
                                    onChange={(e) => setQuestionKind(e.target.value)}
                                >
                                    {Object.entries(QuestionKind).map(([key, value]) => (
                                        <option key={value} value={value}>
                                            {key}
                                        </option>
                                    ))}
                                </select>
                            </label>
                            <button
                                className={`${styles.saveCatBtn}`}
                                onClick={handleGenerate}
                            >
                                Generate
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function DisplayQuestions({ questions }) {
    return (
        <div className={`${styles.questions}`}>
            {questions.map((question, index) => (
                <div key={index} className={`${styles.question}`}>
                    <p>{question}</p>
                </div>
            ))}
        </div>
    );
}